module.exports = __webpack_public_path__ + "static/media/money-transfer.5a0ea90f.png";